import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

export default {
  methods: {
    lookUpGrade(lookupScore, grades) {
      for (let i = 0; i < grades.length; i++) {
        if (
          grades[i].lowScore < lookupScore &&
          grades[i].highScore >= lookupScore
        ) {
          return grades[i];
        }
      }
      return null;
    },
    async build() {
      await this.$nextTick();
      this.chart = am4core.create(this.$refs.chartdiv, am4charts.GaugeChart);
      this.setChartStyle();
      this.setAxis();
      this.setAxis2();
      this.setRanges();
      this.setLabel();
      this.setLabel2();
      this.setHand();
      this.hideAmChartLogo();
      this.removeEmptyDivs();
    },
    setChartStyle() {
      this.chart.hiddenState.properties.opacity = 0;
      this.chart.fontSize = 5;
      this.chart.innerRadius = am4core.percent(60);
      this.chart.resizable = true;
    },
    setAxis() {
      const axis = this.chart.xAxes.push(new am4charts.ValueAxis());
      axis.min = this.chartMin;
      axis.max = this.chartMax;
      axis.strictMinMax = true;
      axis.renderer.ticks.template.strokeOpacity = 0;
      axis.renderer.labels.template.disabled = true;
      axis.renderer.ticks.template.disabled = true;
      axis.renderer.labels.template.radius = am4core.percent(5);
      axis.renderer.labels.template.fontSize = '2em';
    },
    setAxis2() {
      this.axis2 = this.chart.xAxes.push(new am4charts.ValueAxis());
      this.axis2.min = this.chartMin;
      this.axis2.max = this.chartMax;
      this.axis2.renderer.innerRadius = '60%';
      this.axis2.strictMinMax = true;
      this.axis2.renderer.labels.template.disabled = true;
      this.axis2.renderer.ticks.template.disabled = true;
      this.axis2.renderer.grid.template.disabled = false;
      this.axis2.renderer.ticks.template.strokeOpacity = 0;
      this.axis2.renderer.labels.template.bent = true;
      this.axis2.renderer.labels.template.fill = am4core.color('#000');
      this.axis2.renderer.labels.template.fontWeight = 'bold';
    },
    setRanges() {
      for (const grading of this.gradingData) {
        const range = this.axis2.axisRanges.create();
        range.axisFill.fill = am4core.color(grading.color);
        range.axisFill.fillOpacity = 1;
        range.value = grading.lowScore > this.chartMin ? grading.lowScore : this.chartMin;
        range.endValue = grading.highScore < this.chartMax ? grading.highScore : this.chartMax;
        range.grid.strokeOpacity = 0;
        range.stroke = 'transparent';
        range.label.inside = true;
        range.label.text = grading.title.toUpperCase();
        range.label.location = 0.5;
        range.label.radius = am4core.percent(5);
        range.label.paddingBottom = -5; // ~half font size
        range.label.fontSize = '0.9em';
      }

      this.matchingGrade = this.lookUpGrade(this.score.value, this.gradingData);
    },
    setLabel2() {
      const label2 = this.chart.radarContainer.createChild(am4core.Label);
      label2.isMeasured = false;
      label2.fontSize = '2em';
      label2.horizontalCenter = 'middle';
      label2.verticalCenter = 'bottom';
      label2.text = this.matchingGrade.title.toUpperCase();
      label2.fill = am4core.color(this.matchingGrade.color);
    },
    setHand() {
      const hand = this.chart.hands.push(new am4charts.ClockHand());
      hand.axis = this.axis2;
      hand.innerRadius = am4core.percent(45);
      hand.startWidth = 10;
      hand.pin.disabled = true;
      hand.value = this.score.value;
      hand.fill = am4core.color('#444');
      hand.stroke = am4core.color('#000');
    },
    hideAmChartLogo() {
      document.querySelectorAll('div > svg > g > g > g > g > g:nth-child(3)').forEach(div => {
        div.style.display = 'none';
      });
    },
    removeEmptyDivs() {
      const divsStaging = document.querySelectorAll('div[style="width: 200px; height: 200px; top: 0px; left: 0px; visibility: hidden; position: absolute;"]');
      const divsProd = document.querySelectorAll('div[style="width: 200px; height: 200px; visibility: hidden; position: absolute;"]');

      divsStaging.forEach(div => div.remove());
      divsProd.forEach(div => div.remove());
    },
  },
  watch: {
    score: {
      immediate: true,
      handler: 'build',
    },
  },
  beforeUpdate() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
};
